import { RouteGuard, RouteGuardResultType } from 'react-route-guard'


export default class Guard implements RouteGuard {
  /**
   * Route guard to handle authentication (see in Routes component)
   * If no token is found in the sessionStorage, authentication
   */
  shouldRoute(): RouteGuardResultType {
    // Bypass Auth in local development
    if (process.env.NODE_ENV !== 'production') {
      // Set a mock userId
      sessionStorage.setItem('userId', '1')
      // Bypass Auth
      return true
    }
    return sessionStorage.getItem('token') ? true : false
  }
}
